export default __webpack_public_path__ + "static/media/kenya.e0486cd6.jpg";